import { render, staticRenderFns } from "./FilterExpired.vue?vue&type=template&id=7052daca"
import script from "./FilterExpired.vue?vue&type=script&lang=js"
export * from "./FilterExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports